<template>
    <div id="page-content-wrapper">
        <div id="page">
            <div class="main-container">
                <section>
                    <div class="content">
                        <div class="container">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="region region-content">
                                        <section id="block-system-main" class="block block-system clearfix">
                                            <div class="panel-main">
                                                <div id="texte_bordure">
                                                    <slot>
                                                    </slot>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'contenu',
};
</script>

<style scoped>

</style>
